export const BRAND = {
  name: "Le Point de Vue de Tanlay",
  short: "Le Point de Vue",
  place: "Tanlay · Bourgogne",
  signature: "Deux gîtes. Un autre point de vue sur la Bourgogne.",
  subtitle:
    "À Tanlay, entre château, canal et vignobles, deux gîtes indépendants pour ralentir, respirer et retrouver le goût des choses simples.",
  phone: "+33 7 68 50 39 06",
  phoneLink: "tel:+33768503906",
  email: "yvois.anne@orange.fr",
  emailLink: "mailto:yvois.anne@orange.fr",
  languages: ["Français", "Anglais", "Allemand"],
  checkin: "17:00 – 22:00",
  checkout: "08:00 – 12:00",
};

export const HERO_IMG =
  "https://cf.bstatic.com/xdata/images/hotel/max1024x768/751616360.jpg?k=9017fb656632936ef3bd936b6786058513e8689909f3503d06f5be08cab4abd0&o=";

export const GITES = [
  {
    id: "chez-anne",
    path: "/chez-anne-tanlay",
    name: "Chez Anne",
    tagline: "Un gîte lumineux et généreux, ouvert sur une grande terrasse et le paysage.",
    rating: "9,5",
    reviews: 41,
    sqm: 150,
    guests: 5,
    bedrooms: 2,
    highlights: "Cheminée · Grande terrasse · Jardin",
    booking: "https://www.booking.com/hotel/fr/chez-anne-tanlay1.fr.html",
    cover:
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/751616360.jpg?k=9017fb656632936ef3bd936b6786058513e8689909f3503d06f5be08cab4abd0&o=",
    description:
      "Grand gîte de 150 m² baigné de lumière, prolongé par une vaste terrasse qui ouvre sur toute la vallée. Deux chambres, un salon avec cheminée et un jardin arboré composent un lieu paisible où poser ses valises et prendre le temps.",
    features: [
      "150 m²", "5 voyageurs", "2 chambres", "1 salle de bain",
      "Cheminée", "Grande terrasse vue vallée", "Jardin arboré",
      "Cuisine équipée", "Douche à l'italienne", "Wi-Fi gratuit", "Parking privé gratuit", "Animaux admis",
    ],
    gallery: [
      { src: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/751616360.jpg?k=9017fb656632936ef3bd936b6786058513e8689909f3503d06f5be08cab4abd0&o=", alt: "Terrasse fleurie avec vue sur la vallée" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751615638.jpg?k=cef3224b0806c0926fcd1f9c6c01e99472c955663c23fe720fcebb83d33fd897&o=", alt: "Chambre lumineuse avec grande fenêtre" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751615735.jpg?k=4249bc12f6d6d4c4e54f48e3aeefbf783ae3a78d4a906931635dd7e246c16af6&o=", alt: "Chambre avec grand lit" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751616246.jpg?k=dd43a4fbdbe928633870a4cec9e96fe806321b8077be4ee6fac8e1e8ac904a32&o=", alt: "Salon avec canapé" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751616016.jpg?k=fb373375a6c4daf53bf55d0a39dfd955785a3f098b10076fb848324f23dca5bb&o=", alt: "Cuisine équipée" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751615840.jpg?k=1278f3db8d5685196713fb5e84a8fa707c447f6f5e788b778f22ab78c2488c54&o=", alt: "Salle de bain avec douche" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751616326.jpg?k=427900d539d6c1f1b92384503098ab8fceab0e281404594eea3564563b36e675&o=", alt: "Table à manger" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751616529.jpg?k=7580d836ed2858f93d60f4af2ec71194aab39e15d7a20219444df29e09b70173&o=", alt: "Balcon avec salon de jardin" },
    ],
  },
  {
    id: "au-19",
    path: "/au-19-tanlay",
    name: "Au 19",
    tagline: "Un gîte de caractère, paisible et indépendant, pensé pour se retrouver.",
    rating: "9,5",
    reviews: 36,
    sqm: 120,
    guests: 5,
    bedrooms: 2,
    highlights: "Cheminée · Terrasse · Jardin",
    booking: "https://www.booking.com/hotel/fr/au-19.fr.html",
    cover:
      "https://cf.bstatic.com/xdata/images/hotel/max1024x768/751614037.jpg?k=36a894c410e14dabfe7a1a74d9b58ac541e8df1f21adf09d3d19083b0c012db9&o=",
    description:
      "Gîte de 120 m² aux pièces spacieuses et lumineuses, avec cheminée et une salle d'eau avec douche à l'italienne. Sa terrasse ouvre sur la vallée de l'Armançon et un jardin arboré. Un lieu calme et indépendant, à deux pas du village.",
    features: [
      "120 m²", "5 voyageurs", "2 chambres", "1 salle d'eau avec douche à l'italienne",
      "Cheminée", "Terrasse vue vallée de l'Armançon", "Jardin arboré",
      "Cuisine équipée", "Douche à l'italienne", "Wi-Fi gratuit", "Parking privé gratuit", "Animaux admis",
    ],
    gallery: [
      { src: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/751614037.jpg?k=36a894c410e14dabfe7a1a74d9b58ac541e8df1f21adf09d3d19083b0c012db9&o=", alt: "Chambre avec lit et bureau" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751613865.jpg?k=a748be0a19c826235607d7897858ee76e7137fbf7b67c85bcac9ce30d1850d11&o=", alt: "Chambre avec vue par la fenêtre" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/493728871.jpg?k=e14fa5930a7eb78aca8a2568581cb5bad86d5adfb54ae40b314d5ee085783889&o=", alt: "Chambre avec porte-fenêtre" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751613432.jpg?k=2730d6bb7843f7bf46ed5a1c57b86591d156f424161159b0c1d74bb344924687&o=", alt: "Salon avec deux canapés" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751613532.jpg?k=3ef44734e04302a67cb97970c0dc8a34123c695b62415a2891609bf8b68a348b&o=", alt: "Cuisine avec coin repas" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/835070880.jpg?k=5c8788a2c17614004de421e5d68d3828959eb09946920afb13f781c5a96a2c56&o=", alt: "Salle de bain avec douche" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/835071656.jpg?k=676afe65d8f439d81420e73428cfb8bfdd84a01a1b1b93028175d74c87475b92&o=", alt: "Lavabo et miroir de salle de bain" },
      { src: "https://cf.bstatic.com/xdata/images/hotel/max500/751612338.jpg?k=97d1d701f17ea547fbf06a1f0c2ec276849e1ddee07b83c2bbe1bb060f8929f7&o=", alt: "Terrasse avec vue panoramique" },
    ],
  },
];

// Images d'illustration de la Bourgogne (non présentées comme des photos de Tanlay)
export const BOURGOGNE = [
  { title: "Le château de Tanlay", alt: "Le château de Tanlay en Bourgogne", text: "Joyau de la Renaissance entouré de douves, à quelques minutes des gîtes.", link: "https://www.chateaudetanlay.fr/", img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Chateau_Tanlay_facade_cour_grand_chateau.jpg/1280px-Chateau_Tanlay_facade_cour_grand_chateau.jpg", credit: "Photo : Myrabella / Wikimedia Commons / CC BY-SA 4.0" },
  { title: "Le canal de Bourgogne", text: "À longer à pied, à vélo ou en bateau, entre écluses et villages de pierre.", link: "https://www.chablis-tonnerrois.fr/le-canal-de-bourgogne/", img: "https://static.prod-images.emergentagent.com/jobs/16bb327f-3212-490f-a156-8c05474c0d7f/images/24b91f7c65006d42b248dde98ad32346693966fb71ec3f758eff047ac2dbd8fb.jpeg" },
  { title: "Le château d'Ancy-le-Franc", alt: "Le château d'Ancy-le-Franc en Bourgogne", text: "L'un des plus beaux palais Renaissance de France, tout proche.", link: "https://www.chateau-ancy.com/", img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Ancy-le-Franc_Ch%C3%A2teau_d%27Ancy-le-Franc_Cour_d%27Honneur_1.jpg/1280px-Ancy-le-Franc_Ch%C3%A2teau_d%27Ancy-le-Franc_Cour_d%27Honneur_1.jpg", credit: "Photo : Zairon / Wikimedia Commons / CC BY-SA 4.0" },
  { title: "Chablis et ses vignobles", text: "Les grands vins blancs de Bourgogne, à découvrir chez les vignerons.", link: "https://www.chablis-tonnerrois.fr/blog/top-10-activites-a-chablis/", img: "https://images.pexels.com/photos/14816341/pexels-photo-14816341.jpeg" },
  { title: "Promenades à pied et à vélo", text: "Chemins, coteaux et bords de canal : la région se découvre sans programme imposé.", link: "https://www.chablis-tonnerrois.fr/les-randonnees-pedestres/", img: "https://images.unsplash.com/photo-1762119954537-67f8d7351f3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const NAV = [
  { path: "/", label: "Accueil" },
  { path: "/les-maisons", label: "Les gîtes" },
  { path: "/chez-anne-tanlay", label: "Chez Anne" },
  { path: "/au-19-tanlay", label: "Au 19" },
  { path: "/decouvrir-la-bourgogne", label: "Découvrir la Bourgogne" },
  { path: "/preparer-son-sejour", label: "Préparer son séjour" },
  { path: "/contact", label: "Contact" },
];
